import { Component, OnInit, Input, OnDestroy, ElementRef, ViewChild } from '@angular/core';
import { EventService } from '../../shared/services/event.service';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
@Component({
  selector: 'app-all-events',
  templateUrl: './all-events.component.html',
  styleUrls: ['./all-events.component.scss'],
  providers: [NgbModal]
})
export class AllEventsComponent implements OnInit, OnDestroy {
  @Input()
  bypass: boolean;
  @Input()
  user: any;
  events = [];
  eventsActived = [];
  eventsClosed = [];
  lg;
  event: any;
  toBuy: false;
  text: any = {
    Year: 'Year',
    Month: 'Month',
    Weeks: 'Weeks',
    Days: 'Days',
    Hours: 'Hours',
    Minutes: 'Min.',
    Seconds: 'Sec.',
    MilliSeconds: 'MilliSeconds'
  };
  private modalRef: NgbModalRef;
  fetching: { [key: string]: any } = {};
  constructor(
    private eventService: EventService,
    private translateService: TranslateService,
    private modalService: NgbModal,
    private router: Router
  ) {
    // this.eventService.getAll().subscribe(res => {
    //   // console.log(res);
    //   this.events = res;
    // });
    this.eventService
      .getAllSort()
      .orderBy('status', 'desc')
      // .orderBy('year')
      // .orderBy('month')
      // .orderBy('day')
      .onSnapshot(
        snapshot => {
          // this.events = [];
          this.eventsActived = [];
          this.eventsClosed = [];
          snapshot.forEach(doc => {
            // console.log(doc.data());
            // this.events.push(doc.data());
            if (!doc.data().isClose) {
              this.eventsActived.push(doc.data());
            } else if (!doc.data().status && doc.data().isClose) {
              this.eventsClosed.push(doc.data());
            }
          });
          // console.log(this.eventsClosed);
        },
        error => {}
      );
    this.lg = this.translateService.currentLang;
    this.fetching['lg'] = this.translateService.onLangChange.subscribe((event: LangChangeEvent) => {
      // do something
      this.lg = event.lang;
      // if (this.lg === 'th') {
      //   this.text = {
      //     Year: 'ปี',
      //     Month: 'เดือน',
      //     Weeks: 'สัปดาห์',
      //     Days: 'วัน',
      //     Hours: 'ชัวโมง',
      //     Minutes: 'นาที',
      //     Seconds: 'วินาที',
      //     MilliSeconds: 'มิินลิวินาที'
      //   };
      // } else {
      //   this.text = {
      //     Year: 'Year',
      //     Month: 'Month',
      //     Weeks: 'Weeks',
      //     Days: 'Days',
      //     Hours: 'Hours',
      //     Minutes: 'Minutes',
      //     Seconds: 'Seconds',
      //     MilliSeconds: 'MilliSeconds'
      //   };
      // }
    });
  }

  ngOnDestroy() {
    for (const key in this.fetching) {
      if (this.fetching.hasOwnProperty(key) && this.fetching[key]) {
        this.fetching[key].unsubscribe();
      }
    }
  }

  close(value) {
    if (value) {
      this.modalRef.close();
    }
  }

  ngOnInit() {
    // $.getScript('./assets/js/customizer.js');
  }
  fDate(d, m, y) {
    const date = new Date(y, m, d);
    const month_names = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December'
    ];

    const day = date.getDate();
    const month_index = date.getMonth() - 1;
    const year = date.getFullYear();

    return '' + month_names[month_index] + ' ' + day + ', ' + year;
  }

  byOpent() {
    this.open('', this.events[0], true, true);
  }

  open(content, details, toBuy?, bypass?) {
    if (toBuy) {
      this.toBuy = toBuy;
    } else {
      this.toBuy = toBuy;
    }

    if (bypass && this.bypass) {
      if (details.type === 'c') {
        this.router.navigate([
          'user/booking',
          {
            eventId: details.id
          }
        ]);
      } else if (details.type === 'run') {
        this.router.navigate([
          'user/registry',
          {
            eventId: details.id
          }
        ]);
      } else {
        this.router.navigate([
          'user/ordering',
          {
            eventId: details.id
          }
        ]);
      }
    } else {
      this.event = details;
      this.modalRef = this.modalService.open(content, {
        size: 'lg',
        windowClass: 'modal-adaptive'
      });
    }
  }
}
